import { apiFetch } from "./api";

export function uploadImage(file: File) {
  const form = new FormData();
  form.set("file", file);
  return apiFetch<{ key: string; url: string }>("/co/uploads/image", {
    method: "POST",
    body: form,
  });
}
